import React from "react";
import { ShoppingCart, History, MessageCircle, LogOut } from "lucide-react";

const Header = ({ onToggleHistory, onToggleChat, onLogout }) => {
  return (
    <div
      className="
        rounded-2xl mb-6
        bg-[#FFF5E4] border border-[#FFD8A6]
        shadow-[0_8px_25px_rgba(0,0,0,0.08)]
        px-4 py-5 sm:p-8
      "
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">

        {/* LEFT — LOGO + TITLE */}
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 sm:h-12 sm:w-12 rounded-full bg-[#FFE6C7] flex items-center justify-center shadow">
            <ShoppingCart className="w-6 h-6 sm:w-7 sm:h-7 text-[#FF8C00]" />
          </div>

          <div>
            <h1 className="text-xl sm:text-3xl font-extrabold text-[#5A3E2B] leading-tight">
              Intelligent Budget System
            </h1>
            <p className="text-[#7A6248] text-xs sm:text-sm">
              AI-powered shopping that fits your wallet
            </p>
          </div>
        </div>

        {/* RIGHT — BUTTONS */}
        <div className="flex flex-wrap gap-2 sm:gap-3">

          <button
            onClick={onToggleHistory}
            className="
              px-3 py-2 rounded-lg
              bg-[#FF8C00] text-white font-semibold
              shadow hover:brightness-110 transition
              flex items-center gap-2 text-sm
            "
          >
            <History className="w-4 h-4" /> History
          </button>

          <button
            onClick={onToggleChat}
            className="
              px-3 py-2 rounded-lg
              bg-[#FFB67A] text-[#5A3E2B] font-semibold
              shadow hover:bg-[#FFC28F] transition
              flex items-center gap-2 text-sm
            "
          >
            <MessageCircle className="w-4 h-4" /> Assistant
          </button>

          <button
            onClick={onLogout}
            className="
              px-3 py-2 rounded-lg
              bg-red-400 text-white font-semibold
              shadow hover:bg-red-500 transition
              flex items-center gap-2 text-sm
            "
          >
            <LogOut className="w-4 h-4" /> Logout
          </button>

        </div>
      </div>
    </div>
  );
};

export default Header;
